'use client';

import { useMediaQueries } from '@commons/contexts/responsive';
import { API_WEBSITE } from '@commons/utils/constants';

import BusinessMenuDesktop from './Desktop';
import BusinessMenuMobile from './Mobile';

/**
 * List of GardaWorld businesses to display in the BusinessMenu.
 */

export const GARDAWORLD_BUSINESSES = [
  'crisis24',
  'aiia',
  'gardaWorld_security',
  'ecamsecure',
  'best_crowd_management',
  'sesami',
  'gardaWorld_cash',
  'gardaWorld_campus',
  'gardaWorld_federal',
  'talentWorld',
] as const;

/** GardaWorld business translation key. */
export type GardaWorldBusiness = (typeof GARDAWORLD_BUSINESSES)[number];

/**
 * GardaWorld businesses ordered for each Crisis24 website.
 */

export const GARDAWORLD_BUSINESSES_BY_WEBSITE: Record<
  typeof API_WEBSITE,
  readonly GardaWorldBusiness[]
> = {
  crisis24: [
    'gardaWorld_security',
    'ecamsecure',
    'best_crowd_management',
    'gardaWorld_cash',
    'sesami',
    'gardaWorld_federal',
    'aiia',
  ],
  codered: [
    'crisis24',
    'aiia',
    'gardaWorld_security',
    'ecamsecure',
    'best_crowd_management',
    'sesami',
    'gardaWorld_federal',
  ],
  aiia: [
    'crisis24',
    'gardaWorld_security',
    'gardaWorld_federal',
    'ecamsecure',
    'best_crowd_management',
    'gardaWorld_cash',
    'sesami',
  ],
};

/**
 * GardaWorld Footer BusinessMenu component.
 *
 * Renders the appropriate component based on the screen size.
 */

export const BusinessMenu = () => {
  const { ready, minWidth } = useMediaQueries();

  const isMobile = ready && !minWidth.lg;
  const businesses = GARDAWORLD_BUSINESSES_BY_WEBSITE[API_WEBSITE] || GARDAWORLD_BUSINESSES;

  return (
    <>
      {!isMobile && <BusinessMenuDesktop businesses={businesses} />}
      {isMobile && <BusinessMenuMobile businesses={businesses} />}
    </>
  );
};

export default BusinessMenu;
